export default __webpack_public_path__ + "static/media/step3.92acdb6f.png";